import { getNotificationSubscriptionId } from '@app/utils/getNotificationSubscriptionId'

import { withAbortSignal } from '@app/packages/abortContext/actions'
import { asError } from '@app/packages/asError/asError'
import { getNotificationSubscriptionsLayouts } from '@app/packages/internalApi/actions/notification_subscriptions_layouts'

import { profileUserAccountTypeSelector } from '@app/store/selectors/profile'
import {
  failNotificationSubscriptionToggleSlice,
  finishNotificationSubscriptionToggleSlice,
  setNotificationScheme,
  startNotificationSubscriptionToggleSlice,
} from '@app/store/slices/notification_subscriptions'
import { createThunk } from '@app/store/thunk'

import { callInternalApi, callV2Api } from './api'
import { getAbortControllerService } from './contexts/abortControllerService'

export function getNotificationScheme() {
  return createThunk(async (dispatch, getState) => {
    const rawAccountType = profileUserAccountTypeSelector(getState())
    const accountType = rawAccountType !== 'parent' && rawAccountType !== 'sitter' ? 'parent' : rawAccountType
    const resp = await dispatch(callInternalApi(getNotificationSubscriptionsLayouts(accountType)))
    dispatch(setNotificationScheme(resp.data.attributes.layout))
    return resp
  })
}

export function subscribeToNotifications(topic: string, channel: string) {
  return createThunk(dispatch => dispatch(toggleNotificationSubscription(topic, channel, true)))
}

export function unsubscribeFromNotifications(topic: string, channel: string) {
  return createThunk(dispatch => dispatch(toggleNotificationSubscription(topic, channel, false)))
}

function toggleNotificationSubscription(topic: string, channel: string, subscribed: boolean) {
  return createThunk(async dispatch => {
    const { deleteNotificationSubscriptions, postNotificationSubscriptions } = await import('@app/packages/api/v2/actions/notification_subscriptions')
    const abort = dispatch(getAbortControllerService())
    const abortController = abort.createAbortController(`notifications-${topic}-${channel}`)
    const id = getNotificationSubscriptionId({ topic, channel })
    const action = subscribed ? postNotificationSubscriptions(topic, channel) : deleteNotificationSubscriptions(topic, channel)

    dispatch(startNotificationSubscriptionToggleSlice(id, subscribed))
    try {
      await dispatch(withAbortSignal(abortController.signal, callV2Api(action)))
      dispatch(finishNotificationSubscriptionToggleSlice(id))
    } catch (e) {
      dispatch(failNotificationSubscriptionToggleSlice(id, !subscribed, asError(e)))
    }
  })
}
